import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { ProductInfoMap } from '@domains/pdp-common';

interface Props {
  data: ProductInfoMap[] | null;
}

export const OverseaProductInfo = ({ data }: Props) => {
  return (
    <Container>
      {data?.map(({ key, value }) => (
        <Item key={value}>
          <Text color='textSecondary' variant='Body_14_Regular' style={{ minWidth: 80, width: 80 }}>
            {key}
          </Text>
          <Text color='textSecondary' variant='Body_14_Regular'>
            {value}
          </Text>
        </Item>
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px 24px 16px;
`;

const Item = styled.div`
  margin-top: 12px;
  display: flex;
`;
